import React, { Component, createRef } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import store from '../../../../sessionStorage';
import { myLog } from '../../../../utils/Utility';
import { clearUnreadCount } from '../../../action/SocketActions';

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class ActiveVisitMessage extends Component {
    static propTypes = {
        closeMessagePop: PropTypes.func,
        onSendMessage: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            textMessage: '',
            chatImage: '',
            file: null,
            isOpen: false,
            popUpImage: '',
            receiverId: '',
            autoScrollToBottom: true,
            isAPICall: false,
            isScrollHeight: 0,
        };
        this.messagesEndRef = createRef();
        this.chatCotainerRef = React.createRef();
    }

    // componentDidMount
    componentDidMount() {
        this.props.clearUnreadCount();
        sessionStorage.setItem('EducatorChatPopup', true);
        this.scrollToBottom();
    }

    // componentWillUnmount
    componentWillUnmount() {
        if (sessionStorage.getItem('EducatorChatPopup') === 'true') {
            this.props.clearUnreadCount();
        }
        sessionStorage.setItem('EducatorChatPopup', false);
    }

    //componentDidUpdate
    componentDidUpdate(prevProps, prevState) {
        const isNewMessageArrived = prevProps.chatList.length < this.props.chatList.length;
        if (isNewMessageArrived) {
            if (this.state.isAPICall) {
                const chatCotainer = this.chatCotainerRef.current;
                chatCotainer.scrollTop = chatCotainer.scrollHeight - this.state.isScrollHeight;
            } else {
                this.scrollToBottom();
            }
        } else {
            if (this.autoScrollToBottom) {
                this.scrollToBottom();
            }
        }
    }

    // scrollToBottom
    scrollToBottom = () => {
        const chatCotainer = this.chatCotainerRef.current;
        chatCotainer.scrollTop = chatCotainer.scrollHeight;
    };

    //handleScroll
    handleScroll = () => {
        const chatCotainer = this.chatCotainerRef.current;
        const { scrollTop, scrollHeight, clientHeight } = chatCotainer;
        const enableScroll = Math.abs(scrollHeight - scrollTop - clientHeight) < 1;
        if (enableScroll) {
            this.autoScrollToBottom = true;
        } else {
            this.autoScrollToBottom = false;
        }
        if (scrollTop === 0) {
            if (this.props.chatLastPage > this.props.currentChatPage && this.props.chatLastPage) {
                this.props.callChatAPI();
                this.setState({ isAPICall: true, isScrollHeight: scrollHeight });
            }
        } else {
            this.setState({ isAPICall: false });
        }
    };

    autoScrollToBottom = true;

    //sendMessageClicked
    sendMessageClicked = () => {
        const { textMessage, chatImage, receiverId } = this.state;
        if (textMessage.trim() !== '' || chatImage.length !== 0) {
            if (chatImage.length !== 0) {
                this.props.onSendMessage('', chatImage, 1, receiverId);
            } else if (textMessage.length !== 0) {
                this.props.onSendMessage(textMessage, '', 0, receiverId);
            }
            this.resetMessage();
        }
    };

    /**
     *
     */
    resetMessage() {
        this.setState({
            textMessage: '',
            chatImage: '',
            receiverId: '',
        });
    }

    /**
     *
     * @param {*} files
     */
    getFiles(files) {
        this.setState({
            file: URL.createObjectURL(files[0].file),
        });
        let base64Value = '';
        base64Value = files[0].base64;
        this.setState({
            chatImage: base64Value.substring(base64Value.indexOf(',') + 1, base64Value.length),
        });
        myLog('photo', base64Value.substring(base64Value.indexOf(',') + 1, base64Value.length));
        this.sendMessageClicked();
    }

    /**
     *
     * @param {*} isChatLoading
     */
    _renderLoading(isChatLoading) {
        if (isChatLoading) {
            return (
                <div
                    style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#FFF',
                    }}
                >
                    <p>Loaidng......</p>
                </div>
            );
        }
    }

    /**
     *
     * @param {*} chatList
     * @param {*} userType
     */
    _renderMessage(chatList) {
        let index = 0;
        return (
            <>
                {_.map(chatList, (chat) => {
                    index++;
                    // Check if the chat object contains the 'messageId' key and messageType is not 0 before rendering the message
                    if (chat.hasOwnProperty('messageId') && chat.messageType !== 2) {
                        if (
                            chat.senderUserId === store.get('userSession')?.id ||
                            chat.senderUserId === store.get('insAdminSession')?.id
                        ) {
                            return (
                                <div className="flex flex-row-reverse pb-6 md:pb-4" key={index}>
                                    <div className="msg-text">
                                        <div className="p-3 mt-2 text-black break-words rounded bg-[#34373E]">
                                            {chat.message.split(/\n/).map((message) => (
                                                <React.Fragment key={message}>
                                                    {message}
                                                    <br />
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            );
                        } else {
                            if (
                                (chat.privateMessage &&
                                    chat.receiverUserId === store.get('userSession').id) ||
                                !chat.privateMessage
                            ) {
                                return (
                                    <div className="flex pb-6 md:pb-4" key={index}>
                                        <div className="msg-text">
                                            <div className="text-left">
                                                <span
                                                    className="w-32 mr-2 font-medium text-white table-ellipse whitespace-nowrap text-ellipsis"
                                                    title={chat.senderName}
                                                >
                                                    {chat.senderName.length > 15
                                                        ? `${chat.senderName.slice(0, 15)}...`
                                                        : chat.senderName}
                                                    {chat.privateMessage &&
                                                        chat.receiverUserId ===
                                                            store.get('userSession').id && (
                                                            <span className="text-primary">
                                                                {' '}
                                                                (Direct Message)
                                                            </span>
                                                        )}
                                                </span>
                                            </div>
                                            <div className="p-3 mt-2 text-white break-words rounded bg-cyan">
                                                {chat.message.split(/\n/).map((message) => (
                                                    <React.Fragment key={message}>
                                                        {message}
                                                        <br />
                                                    </React.Fragment>
                                                ))}
                                                {/* {chat.message} */}
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        }
                    } else {
                        // Return null if 'messageId' key is not present or messageType is 0 to skip rendering this chat message
                        return null;
                    }
                })}
            </>
        );
    }

    render() {
        const { chatList } = this.props;
        return (
            <>
                <div className="flex items-center justify-between p-4 border-bottom">
                    <h6 className="mb-0 text-lg font-semibold text-black">Chat</h6>
                    <span
                        className="cursor-pointer"
                        onClick={() => {
                            this.props.closeMessagePop();
                            this.props.clearUnreadCount();
                            sessionStorage.setItem('messageSeen', false);
                        }}
                    >
                        <i className="fal fa-xmark fa-lg"></i>
                    </span>
                </div>

                <div
                    className="h-full pr-1 overflow-y-auto grow"
                    onScroll={() => this.handleScroll()}
                    ref={this.chatCotainerRef}
                >
                    <div className="flex flex-col w-full p-4 message-area">
                        {this._renderMessage(chatList)}
                        <div
                            style={{ float: 'left', clear: 'both', marginTop: '10px' }}
                            ref={this.messagesEndRef}
                        />
                    </div>
                </div>
                <div className="flex m-4 rounded-lg bg-card text-area">
                    <div className="relative flex flex-col message-field">
                        {this.props.isClassRoom && (
                            <div className="flex items-center mb-2">
                                <span className="mx-2">To :</span>
                                <select
                                    value={this.state.receiverId}
                                    onChange={(evt) => {
                                        this.setState({ receiverId: evt.target.value });
                                    }}
                                    className="rounded-md border-0 py-1.5 px-2 outline-0 text-white placeholder:text-secondary text-base cursor-pointer whitespace-nowrap text-ellipsis w-32"
                                >
                                    <option value="" className="text-white">
                                        Everyone
                                    </option>
                                    {this.props.streams &&
                                        this.props.streams.map((user, index) => {
                                            let userDetails = this.props.sessionUsers.find(
                                                (e) => e.name === user.name
                                            );
                                            return (
                                                <option
                                                    key={index}
                                                    value={userDetails.userId}
                                                    className="w-32 text-white whitespace-nowrap"
                                                    title={userDetails.name}
                                                >
                                                    {userDetails.name.length > 10
                                                        ? `${userDetails.name.slice(0, 10)}...(${
                                                              userDetails.stuRollNo
                                                          })`
                                                        : `${userDetails.name}(${userDetails.stuRollNo})`}
                                                </option>
                                            );
                                        })}
                                </select>
                            </div>
                        )}
                        <textarea
                            placeholder="Start a Message Here"
                            id="about"
                            name="about"
                            rows="1"
                            maxLength={255}
                            className="block w-full rounded-md border-0 py-1.5 px-2 outline-0 text-black placeholder:text-secondary text-base"
                            value={this.state.textMessage}
                            onChange={(evt) => {
                                // this.autoScrollToBottom = true;
                                this.setState({
                                    textMessage: evt.target.value.trimLeft(),
                                });
                            }}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) this.sendMessageClicked();
                            }}
                        ></textarea>
                    </div>
                    <button
                        className="px-3 bg-white text-primary"
                        onClick={() => {
                            this.sendMessageClicked();
                        }}
                        onKeyPress={() => {
                            this.sendMessageClicked();
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 48 48"
                        >
                            <path
                                fill="currentColor"
                                d="M7.262 4.244c-1.787-.893-3.765.812-3.146 2.711L8.13 19.26a2 2 0 0 0 1.573 1.352l15.86 2.643c.835.14.835 1.34 0 1.48L9.704 27.378a2 2 0 0 0-1.573 1.352L4.116 41.042c-.62 1.9 1.359 3.605 3.146 2.712l35.494-17.742c1.659-.83 1.659-3.197 0-4.026L7.262 4.244Z"
                            />
                        </svg>
                    </button>
                </div>
            </>
        );
    }
}
const mapDispatchtoProps = (dispatch) => {
    return {
        clearUnreadCount: () => {
            dispatch(clearUnreadCount());
        },
    };
};

export default connect(null, mapDispatchtoProps)(ActiveVisitMessage);
